var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{attrs:{"icons-and-text":""}},[_c('v-tabs-slider',{attrs:{"color":"accent"}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }